<template>
  <PerfectScrollbar class="wrapper" :class="{ 'wrapper--bottom-scrollbar': hasBottomScrollbar }">
    <slot />
  </PerfectScrollbar>
</template>

<script>
  import { PerfectScrollbar } from 'vue3-perfect-scrollbar';

  export default {
    name: 'TableScrollbar',
    components: {
      PerfectScrollbar,
    },
    props: {
      hasBottomScrollbar: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>

<style scoped lang="scss">
  .wrapper {
    position: relative;
    padding-top: 16px;
  }

  :deep(.ps__rail-x) {
    top: 0 !important;
    bottom: auto !important;
    height: 10px !important;
  }

  :deep(.ps__thumb-x) {
    height: 100% !important;
  }

  .wrapper--bottom-scrollbar {
    overflow-x: scroll !important;
    scrollbar-width: auto;

    &::-webkit-scrollbar {
      height: 10px;
    }

    &::-webkit-scrollbar-track {
      background: $light-grey-7;
      border-radius: 1rem;
    }

    &::-webkit-scrollbar-thumb {
      background: $light-grey-8;
      border-radius: 1rem;
    }
  }
</style>
